import { OptionDto } from "@/dtos";

const enableSystemOptions = [
    { value: 1, label: 'Si' },
    { value: 2, label: 'No' },
] as OptionDto[];

export const getEnableSystemOptions = (): OptionDto[] => {
    return enableSystemOptions;
}

export const getEnableSystemOption = (value: number): OptionDto => {
    return enableSystemOptions.find((x) => x.value == value) ?? enableSystemOptions[0];
}
